import React, { createContext, useContext, useEffect, useState } from "react";
import client, { mediaUrl } from "../lib/api";
import defaultSymbol from "../assets/brand/logo-symbol.png";

const BrandContext = createContext(null);
const DEFAULT_NAME = "SRI AKILANDESWARI AMMAN TRUST";
const DEFAULT_TAGLINE = "Compassion • Growth • Service";

export function BrandProvider({ children }) {
  const [branding, setBranding] = useState({ trustName: DEFAULT_NAME, tagline: DEFAULT_TAGLINE, primaryLogo: "", compactLogo: "", favicon: "" });

  useEffect(() => {
    client.get("/public/branding/current").then(({ data }) => setBranding((b) => ({ ...b, ...data }))).catch(() => {});
  }, []);

  useEffect(() => {
    const href = branding.favicon ? mediaUrl(branding.favicon) : "/favicon.png";
    let link = document.querySelector("link[rel='icon']");
    if (!link) { link = document.createElement("link"); link.rel = "icon"; document.head.appendChild(link); }
    link.href = href;
  }, [branding.favicon]);

  const symbol = branding.primaryLogo ? mediaUrl(branding.primaryLogo) : defaultSymbol;
  const compact = branding.compactLogo ? mediaUrl(branding.compactLogo) : symbol;
  const tagline = branding.tagline || DEFAULT_TAGLINE;
  const trustName = branding.trustName || DEFAULT_NAME;

  return (
    <BrandContext.Provider value={{ branding, symbol, compact, tagline, trustName, defaultSymbol }}>
      {children}
    </BrandContext.Provider>
  );
}

export const useBrand = () => useContext(BrandContext) || { symbol: defaultSymbol, compact: defaultSymbol, tagline: DEFAULT_TAGLINE, trustName: DEFAULT_NAME };
